import { DateTime } from 'luxon';
import type { ILegBase } from '../models/leg-base.model';
import type { INote } from '../models/note.model';
import { CallHelper } from './call.helper';
import { DateTimeHelper } from './date-time.helper';

export class LegHelper {
  public static isTripLeg(leg: ILegBase): boolean {
    return leg !== undefined && 'serviceJourney' in leg; // Check because typescript interfaces are not classes: determine if leg is a trip leg, only trip legs contains a service journey
  }

  public static isConnectionLink(leg: ILegBase): boolean {
    return leg !== undefined && 'distanceInMeters' in leg;
  }

  public static getAllNotes(leg: ILegBase): INote[] {
    return ([] as INote[])
      .concat(leg.notes || [])
      .concat(leg.origin.notes || [])
      .concat(leg.destination.notes || []);
  }

  public static getAllTripLegNotes(leg: ILegBase): INote[] {
    return ([] as INote[])
      .concat(leg.notes?.filter((x) => x.type !== 'guaranteed-change') || [])
      .concat(leg.origin.notes || [])
      .concat(leg.destination.notes || []);
  }

  public static getGuaranteedChangeNotes(leg: ILegBase): INote[] {
    return leg.notes?.filter((x) => x.type === 'guaranteed-change') ?? [];
  }

  public static isDepartureOnTime(leg: ILegBase) {
    return CallHelper.isOnTime(leg.origin);
  }

  public static isArrivalOnTime(leg: ILegBase) {
    return CallHelper.isOnTime(leg.destination);
  }

  public static getDepartureTime(leg: ILegBase, useEstimatedTime: boolean): DateTime {
    return CallHelper.getTime(leg.origin, useEstimatedTime);
  }

  public static getArrivalTime(leg: ILegBase, useEstimatedTime: boolean): DateTime {
    return CallHelper.getTime(leg.destination, useEstimatedTime);
  }

  public static getDurationInMinutes(leg: ILegBase, useEstimatedTime: boolean): number {
    const timeAtOrigin = this.getDepartureTime(leg, useEstimatedTime);
    const timeAtDestination = this.getArrivalTime(leg, useEstimatedTime);

    return DateTimeHelper.minutes(timeAtOrigin, timeAtDestination);
  }
}
